module.exports = "https://activity.hdslb.com/blackboard/activity38602/static/img/logo_9458f2f.png";